<script setup lang="ts"></script>

<template>
  <!-- TODO: Implement dynamic logo/footer -->
  <main class="h-full">
    <div class="flex h-full min-h-screen flex-col justify-between gap-5">
      <div class="mt-10">
        <img class="mx-auto w-full max-w-48" src="/images/logo.svg" alt="Flokee" />
      </div>
      <div class="container mx-auto flex animate-fadeIn flex-col">
        <RouterView />
      </div>
      <div class="flex px-10 py-5 align-bottom">
        <div class="flex w-full flex-col-reverse justify-between gap-5 text-sm lg:flex-row">
          <p class="m-0 mx-auto text-center">© {{ new Date().getFullYear() }} Flokee</p>
        </div>
      </div>
    </div>
  </main>
</template>

<style scoped lang="scss"></style>
